import styled from "@emotion/styled"
import { Container, Typography } from "@mui/material"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import CustomButton from "../../components/custom-button/custom-button.component"

export const Section = styled(SectionWrapper)`
  position: relative;
  padding-top: 4.5rem;
  padding-bottom: ${({ theme }) => theme.typography.pxToRem("100")};
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-top: ${({ theme }) => theme.typography.pxToRem("110")};
    padding-bottom: ${({ theme }) => theme.typography.pxToRem("175")};
  }
`

export const Wrapper = styled(Container)`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: space-between;
  /* margin-top: 1.75rem; */
  max-width: 750px;
  align-items: center;
  gap: 1.25rem;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    gap: 2.5rem;
  }
`

export const Title = styled(Typography)`
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 2.25rem;
  font-weight: 400;
  line-height: 3rem;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    line-height: 4.5rem;
    font-size: 3.5rem;
  }
`

export const Description = styled(Typography)`
  text-align: center;
  line-height: 1.5rem;
  letter-spacing: 0.015rem;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: 1.0625rem;
    line-height: 1.75rem;
    letter-spacing: 0.01063rem;
  }
`
export const DamnCustomButton = styled(CustomButton)`
  margin-top: 2.5rem;
  gap: 0.75rem;
  background-color: #eec249;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    margin-top: 3rem;
  }
`

export const StatisticsWrapper = styled(Container)`
  display: flex;
  flex-direction: row;
  position: relative;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  margin-top: 4.5rem;

  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 2.5rem;
    padding-top: 1rem;
    margin-top: ${({ theme }) => theme.typography.pxToRem("92")};
    border-top: 1px solid #000;
    min-width: 56rem;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    padding-left: ${({ theme }) => theme.typography.pxToRem("40")};
    padding-right: ${({ theme }) => theme.typography.pxToRem("40")};
  }
`
export const StatisticsDescription = styled(Typography)`
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1.5rem;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: 1.0625rem;
    line-height: 1.75rem;
  }
`

export const StatisticsNumber = styled(Typography)`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 4rem;
  font-style: normal;
  font-weight: 400;
  line-height: 5rem;
  letter-spacing: 0.04rem;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: 4rem;
    line-height: 5rem;
  }
`
